<template>

    <van-list
            v-model="loading"
            :finished="listFinished"
            finished-text="没有更多了"
            @load="loadData">
        <van-cell-group>
            <van-cell v-for="(item, index) in articleList" :key="index" :to="'/article/detail?id='+ item.id"
                      :title="item.title"/>
        </van-cell-group>
    </van-list>
</template>

<script>
    import {util} from '@/libs/util'
    import {getArticleList} from '@/api/article'
    import moment from 'moment'
    import Vue from "vue";
    import {Cell, CellGroup, List} from "vant";

    Vue.use(Cell)
        .use(CellGroup)
        .use(List)

    export default {
        name: "article-list",
        data() {
            return {
                pageNo: 1,
                pageSize: 10,
                type: null,
                articleList: [],
                loading: false,
                listFinished: false
            }
        },

        methods: {
            formatTime(e) {
                return moment(e).format('YYYY-MM-DD HH:mm')
            },
            loadArticle() {
                this.loading = true
                getArticleList(this.type, this.pageNo, this.pageSize, "banner").then(res => {
                    this.loading = false
                    const data = res.data
                    if (data.code == 0) {
                        this.articleList = this.articleList.concat(data.articleList)
                        if (data.hasNextPage) {
                            this.listFinished = false
                        } else {
                            this.listFinished = true
                        }
                    } else {
                        this.listFinished = true
                        util.showModal("获取文章列表失败", data.msg)
                    }
                    this.pageNo++
                })
            },
            loadData() {
                this.loadArticle()
            }
        },
        created() {
            this.type = this.$route.query.type
        },
    }
</script>

<style lang="less">


</style>
